import { useState, useEffect } from 'react';
import axios from 'axios';
import { format } from 'date-fns';

const API_BASE = import.meta.env.VITE_API_URL || '/api';

export default function CallHistory({ campaignId }) {
  const [calls, setCalls] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchCalls();
  }, [campaignId]);

  const fetchCalls = async () => {
    try {
      setLoading(true);
      const token = localStorage.getItem('accessToken');
      const params = new URLSearchParams({
        campaign_id: campaignId,
        limit: '20'
      });

      const response = await axios.get(
        `${API_BASE}/dialer/calls?${params}`,
        { headers: { Authorization: `Bearer ${token}` } }
      );
      setCalls(response.data || []);
    } catch (error) {
      console.error('Error fetching call history:', error);
    } finally {
      setLoading(false);
    }
  };

  const getStatusColor = (status) => {
    switch (status) {
      case 'answered':
        return 'text-green-600';
      case 'no_answer':
        return 'text-yellow-600';
      case 'busy':
        return 'text-orange-600';
      case 'failed':
        return 'text-red-600';
      default:
        return 'text-gray-600';
    }
  };

  const formatDuration = (seconds) => {
    if (!seconds) return '0s';
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}m ${secs}s`;
  };

  return (
    <div className="bg-white rounded-lg shadow-lg p-6">
      <h3 className="text-lg font-semibold mb-4">Call History</h3>

      {loading ? (
        <div className="text-center py-4">Loading...</div>
      ) : calls.length === 0 ? (
        <div className="text-center py-4 text-gray-500">No calls yet</div>
      ) : (
        <div className="space-y-3 max-h-96 overflow-y-auto">
          {calls.map((call) => (
            <div key={call.id} className="border rounded p-3">
              <div className="flex items-center justify-between">
                <div>
                  <div className="font-semibold">{call.full_name || 'Unknown'}</div>
                  <div className="text-sm text-gray-600">{call.phone_number}</div>
                  {call.start_time && (
                    <div className="text-xs text-gray-500 mt-1">
                      {format(new Date(call.start_time), 'MMM d, h:mm a')}
                    </div>
                  )}
                </div>
                <div className="text-right">
                  <div className={`text-sm font-semibold ${getStatusColor(call.status)}`}>
                    {call.status}
                  </div>
                  {call.duration > 0 && (
                    <div className="text-xs text-gray-500">
                      {formatDuration(call.duration)}
                    </div>
                  )}
                </div>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}


